import { FC } from "react";
import { getBreadcrumbs } from "use-react-router-breadcrumbs";
import { Link, useLocation } from "react-router-dom";
import BackButtonArrowSVG from "../components/resources/svg/functional/BackButtonArrowSVG";
import DividerSVG from "../components/resources/svg/functional/DividerSVG";
import HouseIconSVG from "../components/resources/svg/HouseIconSVG";
import BreadCrumbsArrowSVG from "../components/resources/svg/functional/BreadCrumbsArrowSVG";
import { breadcrumbsFactory } from "../routes/breadcrumbs";
import { useTranslation } from "react-i18next";

const CustomBreadCrumbs: FC = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const breadcrumbs = getBreadcrumbs({ routes: breadcrumbsFactory(t), location });

    return (
        <div className="relative h-[80px] overflow-x-auto no-scrollbar">
            <div className="absolute flex justify-start items-center left-0 right-0 dmin2:max-w-[1280px] min-w-max dmin2:mx-auto di6:mx-[26px] ti6:mx-8 ti7:mx-5 tmax4:mx-[15px] h-full">
                <div className="H16B text-textWhite flex items-center">
                    <BackButtonArrowSVG className="mr-1 mt-[1px]" />
                    <Link to="/" className="text-textWhite">
                        {t("routes.backButton")}
                    </Link>
                </div>
                <DividerSVG className="mx-3" />
                {breadcrumbs.map(({ match, breadcrumb }, index) => (
                    <div
                        key={match.pathname}
                        className={`H16 text-textFaded hover:text-textWhite flex items-center transition-all duration-300 group ${
                            index < breadcrumbs.length - 1 ? "mr-2" : ""
                        }`}
                    >
                        {index === 0 ? (
                            <HouseIconSVG className="mr-1 group-hover:text-textWhite transition-all duration-300" />
                        ) : null}
                        <Link to={match.pathname} className="flex items-center">
                            {breadcrumb}
                        </Link>
                        {index < breadcrumbs.length - 1 && (
                            <BreadCrumbsArrowSVG className="mx-1 mt-[1px] group-hover:text-textWhite transition-all duration-300" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomBreadCrumbs;
